module.exports = "/_next/static/images/github-49129f0b0aca0944f87148cbbf71195c.svg";